import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=55956ad1&"
import script from "./AddAccount.vue?vue&type=script&lang=js&"
export * from "./AddAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports